import ActivatePage from "./pages/ActivatePage";

export default [
  { path: "/activate", element: <ActivatePage /> }
];
